import { User } from './../_models/user';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHeaders, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { NgxSpinnerService } from "ngx-spinner";

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private spinner: NgxSpinnerService
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).do(
            // tslint:disable-next-line: no-empty
            (event: HttpEvent<any>) => {
                this.spinner.show();
                if (event instanceof HttpResponse) {
                    const newToken = event.headers.get('X-NewToken');
                    if (newToken && newToken.length > 0) {
                        let user: User = JSON.parse(localStorage.getItem('currentUser'));
                        user.token = newToken;
                        localStorage.setItem('currentUser', JSON.stringify(user));
                    }
                  }
            },
            (err: any) => {
                this.spinner.hide();

                if (err.status === 401) {
                    alert('Sua sessão expirou.');
                    this.router.navigate(['/extra/login']);
                    return;
                }

                next.handle(request);
            },
            () => {
                this.spinner.hide();
            }
            );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/_services/interceptor.module.ts